import React, { createContext, useEffect, useState } from "react";
import { getBlogs, getWebParts } from "../services/api";


//context
export const dataContext = createContext();
const DataContextProvider = (props) => {
    const [allWebParts, setAllWebParts] = useState()
    useEffect(() => {
          const fetchApiWebParts = async () => {
            const data = await getWebParts()
            setAllWebParts(data);
          };
          fetchApiWebParts();
      }, []);

      
    const [blogHome, setBlogHome] = useState()
    useEffect(() => {
          const fetchApiWebParts = async () => {
            const data = await getBlogs()
            setBlogHome(data);
          };
          fetchApiWebParts();
      }, []);



  return (
    <dataContext.Provider value={{allWebParts,blogHome}}>
        {props.children}
    </dataContext.Provider>
  )
}

export default DataContextProvider